import React, { useState, useCallback, useEffect } from "react";
import { MoveFocusInside } from "react-focus-lock";
import { useDispatch } from "react-redux";
import { Paper, ResizeTransition } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import { fetchProjectsDetails } from "~/store/actions/actions.projects";
import { ProjectList } from "../MenuSelector/ProjectList";

const WIDTH = 350;

const ProjectsListSelectorContainer = ({ onChooseProject, className }) => {
  const dispatch = useDispatch();

  const [height, setHeight] = useState(72);

  const handleHeight = useCallback((element) => {
    setHeight(element?.offsetHeight ? element.offsetHeight : 0);
  }, []);

  useEffect(() => {
    dispatch(fetchProjectsDetails());
  }, [dispatch]);

  return (
    <Paper
      type="paper-2"
      className={classnames("tw-absolute tw-overflow-hidden", className)}
    >
      <ResizeTransition
        in
        onEnter={handleHeight}
      >
        <div style={{ height, width: WIDTH }}>
          <MoveFocusInside>
            <ProjectList
              onClick={onChooseProject}
              onHeightChange={setHeight}
              style={{ width: WIDTH }}
              focusInput
            />
          </MoveFocusInside>
        </div>
      </ResizeTransition>
    </Paper>
  );
};

ProjectsListSelectorContainer.propTypes = {
  className: PropTypes.string,
  onChooseProject: PropTypes.func,
};

export default ProjectsListSelectorContainer;
